import React from "react";
import logo from "../../assets/logo.webp";
import { usePageSeo } from "../../seo/usePageSeo";
import "./PoliticaPrivacidade.scss";

// Página avulsa: existe só para ser anexada nas fichas da Play Store e da App
// Store. Não é alcançável por nenhum link dentro do app — só pela URL direta.
// O texto é institucional e deve ser copiado literalmente; não reescreva.
const INTRO = [
  "Esta Política de Privacidade descreve de que maneira a AgendaUni realiza a coleta e o tratamento de dados pessoais de estudantes, responsáveis e usuários. Este documento integra os Termos de Uso e busca apresentar, de maneira clara e transparente, como os dados pessoais são tratados.",
  "Ao utilizar a AgendaUni, você declara estar ciente e de acordo com o tratamento de seus dados conforme as disposições desta Política e a legislação aplicável à proteção de dados pessoais.",
];

const SECOES = [
  {
    titulo: "Quem somos?",
    paragrafos: [
      "A AgendaUni é uma plataforma desenvolvida com o propósito de facilitar a comunicação, a organização e o gerenciamento das atividades entre instituições de ensino e seus integrantes. A plataforma busca reunir, em um único ambiente, informações relevantes, como eventos, avisos, comunicados e outras atividades, contribuindo para uma rotina mais organizada de estudantes, professores, coordenadores e gestores.",
    ],
  },
  {
    titulo: "Conceitos importantes",
    paragrafos: [
      "Para tornar esta Política mais fácil de compreender, são utilizadas as definições previstas na Lei Geral de Proteção de Dados (LGPD):",
      "Titular de Dados: pessoa física a quem os dados pessoais estão relacionados, como estudantes, pais ou colaboradores.",
      "Dado Pessoal: qualquer informação capaz de identificar uma pessoa ou que possa permitir sua identificação, como nome, CPF ou e-mail.",
      "Tratamento: qualquer atividade realizada envolvendo dados pessoais, incluindo coleta, acesso, processamento, utilização e armazenamento.",
      "Finalidade: propósito para o qual determinada informação é utilizada.",
    ],
  },
  {
    titulo: "Quem pode utilizar a AgendaUni?",
    paragrafos: [
      "A AgendaUni destina-se exclusivamente às instituições de ensino e aos usuários que tenham sido autorizados, pela instituição, a utilizar a plataforma.",
    ],
  },
  {
    titulo: "Dados coletados e finalidades",
    paragrafos: [
      "A AgendaUni realiza o tratamento de determinadas categorias de dados pessoais necessárias ao funcionamento, à gestão e à segurança da plataforma.",
      "Identificação e Contato: Nome completo e e-mail.",
      "Finalidade: realização do cadastro de acesso, comunicação e organização das turmas.",
      "Dados Acadêmicos e pedagógicos: Senha institucional.",
      "Finalidade: realização do cadastro de acesso, comunicação e organização das turmas.",
      "Além das finalidades mencionadas, os dados pessoais também poderão ser tratados para:",
      "(i) cumprimento de obrigações legais e regulatórias;",
      "(ii) atendimento de solicitações realizadas por autoridades competentes;",
      "(iii) prevenção de fraudes e proteção da segurança dos usuários;",
      "(iv) aprimoramento e aperfeiçoamento da AgendaUni.",
      "A AgendaUni não disponibiliza cadastro por meio de contas Google, Apple ou outros provedores externos. Também não solicita informações pessoais além daquelas necessárias para o funcionamento da plataforma.",
    ],
  },
  {
    titulo: "Permissão de notificações",
    paragrafos: [
      "A plataforma solicita a permissão para notificações com a finalidade exclusiva de enviar avisos, comunicados e informações relacionadas às funcionalidades da AgendaUni.",
      "As notificações têm finalidade exclusivamente funcional e não são utilizadas para publicidade ou marketing.",
      "O usuário poderá optar por permitir ou não o recebimento de notificações. A recusa dessa permissão poderá afetar o funcionamento de determinadas funcionalidades da plataforma.",
      "A AgendaUni não realiza a coleta de dados de localização ou GPS.",
    ],
  },
  {
    titulo: "Controlador e Operador",
    paragrafos: [
      "A instituição contratante será responsável por garantir a legitimidade do fornecimento dos dados pessoais e atuará como controladora desses dados. O CONTRATADO (AgendaUni), por sua vez, realizará o tratamento necessário para o funcionamento da plataforma, na condição de operador.",
    ],
  },
  {
    titulo: "Cookies",
    paragrafos: [
      "A AgendaUni utiliza cookies estritamente necessários para o funcionamento da plataforma e para manter o usuário conectado.",
      "Categoria: Estritamente necessário",
      "Finalidade: manter o usuário conectado, possibilitando a renovação da sessão e o recurso de “continuar conectado”.",
    ],
  },
  {
    titulo: "Armazenamento de dados",
    paragrafos: [
      "Para possibilitar o funcionamento adequado da AgendaUni, determinados dados poderão ser armazenados temporariamente no navegador ou no dispositivo utilizado pelo usuário.",
      "Essas informações podem compreender dados necessários para manter o acesso à conta, informações básicas do perfil, preferências de navegação, recursos relacionados à segurança do acesso e informações temporárias necessárias ao funcionamento de determinadas funcionalidades, inclusive em situações de ausência de conexão com a internet.",
      "No aplicativo, as informações relacionadas ao acesso à conta são armazenadas de maneira segura, utilizando os mecanismos de proteção disponíveis no próprio dispositivo.",
      "Os dados armazenados localmente serão excluídos quando o usuário realizar logout, desinstalar o aplicativo ou limpar os dados armazenados pelo navegador, conforme aplicável.",
    ],
  },
  {
    titulo: "Compartilhamento de dados",
    paragrafos: [
      "Os dados pessoais tratados pela plataforma não serão vendidos, comercializados ou utilizados com finalidade de exploração comercial.",
      "O compartilhamento poderá ocorrer somente quando necessário para a prestação e o funcionamento dos serviços, para a gestão institucional e administrativa, ou com provedores de tecnologia e serviços essenciais, incluindo empresas responsáveis por hospedagem em nuvem, segurança da informação e infraestrutura tecnológica.",
      "Também poderá haver compartilhamento com órgãos públicos quando isso for necessário para o cumprimento de obrigações legais ou regulatórias.",
    ],
  },
  {
    titulo: "Segurança e armazenamento",
    paragrafos: [
      "Os dados pessoais tratados pela AgendaUni são mantidos em servidores seguros localizados no Brasil, com acesso controlado e limitado a pessoas e sistemas autorizados. Para proteger essas informações contra acessos indevidos, perda, alteração ou utilização inadequada, a plataforma adota medidas técnicas e organizacionais de segurança.",
      "As informações são transmitidas de maneira segura e contam com mecanismos de criptografia para sua proteção. As senhas dos usuários não são armazenadas de forma que possam ser visualizadas ou lidas pela plataforma, sendo aplicadas técnicas específicas para garantir sua proteção.",
      "O acesso às contas também conta com mecanismos de autenticação e segurança, como tokens de acesso com validade limitada, controle de tentativas de login e verificação das permissões diretamente no servidor.",
      "Dados armazenados: a AgendaUni poderá armazenar nome, e-mail, tipo de usuário, instituição e turmas às quais o usuário pertence, eventos e interações realizadas na plataforma, informações necessárias para o envio de notificações e registros relacionados à segurança e auditoria, como endereço IP.",
      "Período de Guarda: os dados permanecerão armazenados enquanto forem necessários para o funcionamento da plataforma e para a manutenção do vínculo do usuário com a instituição. Após esse período, poderão ser conservados pelo prazo necessário ao cumprimento de obrigações legais ou regulatórias ou ao exercício regular de direitos.",
      "Compartilhamento com terceiros: a AgendaUni utiliza o Google Firebase exclusivamente para o envio de notificações push. Para essa finalidade, poderão ser enviados os dados necessários à execução do serviço, como o identificador do dispositivo e o conteúdo da notificação. A plataforma não utiliza serviços de publicidade, rastreamento ou análise de terceiros para o tratamento dos dados dos usuários.",
      "Responsabilidade do usuário: cabe ao usuário manter suas credenciais de acesso em sigilo, evitando compartilhá-las com terceiros, além de adotar cuidados adequados para proteger sua conta e o dispositivo utilizado para acessar a plataforma.",
    ],
  },
  {
    titulo: "Exclusão de dados",
    paragrafos: [
      "A exclusão de dados ocorre de forma imediata e definitiva. Após a exclusão, o registro é removido diretamente do banco de dados. Quando um usuário é excluído pelo administrador, são removidos, na mesma operação:",
      "cadastro do usuário, incluindo nome, hash da senha, tipo e instituição;",
      "vínculos com turmas, sejam eles de aluno, responsável ou coordenador;",
      "eventos criados pelo usuário;",
      "tokens de sessão e de redefinição de senha;",
      "tokens de notificações push associados aos seus dispositivos.",
      "Informações que podem permanecer após a exclusão: mesmo após a exclusão, determinadas informações poderão permanecer temporariamente em situações específicas:",
      "Registros de auditoria: são mantidos para fins de segurança e prestação de contas, registrando informações como quem realizou a exclusão, o que foi excluído, quando ocorreu e o respectivo endereço IP. Informações sensíveis, como senhas e tokens, permanecem mascaradas nesses registros.",
      "Backups: os dados excluídos poderão permanecer nas cópias de segurança por até 7 dias, até que ocorra a substituição e descarte do backup mais antigo.",
    ],
  },
  {
    titulo: "Seus direitos",
    paragrafos: [
      "O titular dos dados, ou seu responsável legal, poderá solicitar, observados os limites e as condições previstos na legislação de proteção de dados pessoais, a qualquer momento:",
      "confirmação da existência e acesso aos dados tratados;",
      "correção de informações incompletas, incorretas ou desatualizadas;",
      "eliminação de dados tratados com base no consentimento, respeitados os prazos legais de guarda;",
      "informações sobre as entidades com as quais os dados foram compartilhados.",
      "As solicitações serão avaliadas de acordo com a LGPD e demais normas aplicáveis. Em determinadas situações, por razões legais, regulatórias, educacionais ou de segurança, a solicitação poderá não ser atendida integralmente. Nesses casos, o titular será informado sobre os motivos da impossibilidade, sempre que essa comunicação for exigida pela legislação.",
    ],
  },
  {
    titulo: "Alterações desta política",
    paragrafos: [
      "Esta Política de Privacidade poderá ser atualizada sempre que necessário, especialmente em razão de alterações na legislação, nas funcionalidades da plataforma ou nas formas de tratamento dos dados pessoais.",
      "Quando houver mudanças relevantes, uma nova versão da Política será disponibilizada em local apropriado.",
    ],
  },
];

const EMAIL_CONTATO = "uniagenda.contato@gmail.com";
const CONTATO_TITULO = "Dúvidas ou Comentários?";
const CONTATO_ANTES =
  "Se tiver dúvidas, não hesite em nos contatar através do e-mail ";
const CONTATO_DEPOIS = ".";
const LEGISLACAO =
  "Esta Política de Privacidade é regida pela legislação brasileira, especialmente pela Lei nº 13.709/2018 (Lei Geral de Proteção de Dados Pessoais – LGPD)";

export default function PoliticaPrivacidade() {
  usePageSeo({
    title: "Política de Privacidade – AgendaUni",
    description:
      "Como a AgendaUni coleta, utiliza, armazena, compartilha e protege os dados pessoais dos usuários, em conformidade com a LGPD (Lei nº 13.709/2018).",
    path: "/politica-de-privacidade",
  });

  return (
    <div className="politica-privacidade">
      <img className="politica-privacidade__brand" src={logo} alt="AgendaUni" />

      <main className="politica-privacidade__card">
        <h1 className="politica-privacidade__title">
          Política de Privacidade – AgendaUni
        </h1>

        {INTRO.map((paragrafo, indice) => (
          <p className="politica-privacidade__texto" key={indice}>
            {paragrafo}
          </p>
        ))}

        {SECOES.map((secao) => (
          <section className="politica-privacidade__secao" key={secao.titulo}>
            <h2 className="politica-privacidade__subtitulo">{secao.titulo}</h2>
            {secao.paragrafos.map((paragrafo, indice) => (
              <p className="politica-privacidade__texto" key={indice}>
                {paragrafo}
              </p>
            ))}
          </section>
        ))}

        <section className="politica-privacidade__secao">
          <h2 className="politica-privacidade__subtitulo">{CONTATO_TITULO}</h2>
          <p className="politica-privacidade__texto">
            {CONTATO_ANTES}
            <a href={`mailto:${EMAIL_CONTATO}`}>{EMAIL_CONTATO}</a>
            {CONTATO_DEPOIS}
          </p>
          <p className="politica-privacidade__texto">{LEGISLACAO}</p>
        </section>
      </main>
    </div>
  );
}
